import type { DealOaApi } from '@openx/types/deal';
import type { OptionsMap } from '@openx/types/options';
import { toUTCDate } from '@openx/utils/lib/date';

export const formatDownloadDealDetails = (
  dealData: DealOaApi[],
  demandPartners: OptionsMap,
  adCategory: OptionsMap
) => {
  let dealParticipants, demandPartnersList, result, expectedAdCategory;
  const formattedData: Record<string, unknown>[] = [];

  dealData.forEach(dealItem => {
    const endDate = toUTCDate(dealItem.end_date);

    dealParticipants = dealItem.deal_participants;
    demandPartnersList = dealParticipants.map(({ demand_partner: demandPartner }) => {
      const demandPartnersData: string[] = [];
      if (demandPartners[demandPartner] !== undefined) {
        demandPartnersData.push(demandPartners[demandPartner].name);
      }
      return demandPartnersData;
    });

    if (dealItem.expected_ad_category) {
      expectedAdCategory = adCategory[dealItem.expected_ad_category]?.name ?? dealItem.expected_ad_category;
    }

    result = {
      ...dealItem,
      audienceName: dealItem._package?.audience?.name ?? 'N / A',
      deal_price: dealItem.deal_price?.toString().concat(' ', dealItem.currency || 'USD'),
      demandPartnersList: demandPartnersList.toString(),
      end_date: endDate ? `${endDate} UTC` : 'N / A',
      expected_ad_category: expectedAdCategory ?? 'N / A',
      organization: dealItem.account?.name,
      start_date: toUTCDate(dealItem.start_date)?.concat(' ', 'UTC'),
    };
    formattedData.push(result);
  });
  return formattedData;
};
